export default __webpack_public_path__ + "static/media/grafema_martini-contest_02.96334239.mp4";